// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"605a5551","498":"859303fb","703":"d37b6cd3"}[chunkId] + ".chunk.js";
};